document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.slider__track');
  if (!slider) return;

  // Cache widths instead of recalculating constantly
  let cachedWidth = slider.offsetWidth;

  const recalc = () => {
    requestAnimationFrame(() => {
      const newWidth = slider.scrollWidth;
      if (newWidth !== cachedWidth) {
        slider.style.width = newWidth + 'px';
        cachedWidth = newWidth;
      }
    });
  };

  window.addEventListener('resize', () => {
    clearTimeout(window._resizeTimer);
    window._resizeTimer = setTimeout(recalc, 200);
  });
});